import React from "react";
import styles from "./TableComponent.module.scss";
import { tableHeaders } from "./constants";
import clsx from "clsx";

const TableComponent = ({ rowCount = 6 }) => {
  return (
    <div className={styles.tableWrapper}>
      <div className={styles.table}>
        <div className={styles.headerRow}>
          {tableHeaders.map((header) => (
            <div key={header} className={styles.cellHeader}>
              {header}
            </div>
          ))}
        </div>

        {Array.from({ length: rowCount }).map((_, index) => (
          <div
            key={index}
            className={clsx(styles.dataRow, {
              [styles.evenRow]: index % 2 === 0,
              [styles.oddRow]: index % 2 !== 0,
            })}
          >
            {tableHeaders.map((_, idx) => (
              <div key={idx} className={styles.cell}></div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableComponent;
